<template>
  <InputComponent
    :icon="['fal', 'search']"
    icon-placement="right"
    :label="$t('search')"
    :placeholder="placeholder"
    :value="value"
    @input="$ev => $emit('input', $ev)"
    type="search"
  />
</template>

<script>
import { InputComponent } from 'vue-elder-input'

export default {
  props: ['value', 'options'],
  computed: {
    placeholder() {
      return this.$path('options.placeholder')
    },
  },
  components: {
    InputComponent,
  },
}
</script>

<style lang="scss"></style>
